<template lang="">
    <div class="modal">
        <a class="modal_close" @click="$emit('close')"></a>
        <div class="modal_header">
            <div class="title">조의금 전하기</div>
            <p class="txt"> 위로의 마음을 담아 조의금을 전달해 보세요 </p>
        </div>
        <ul v-if="safeMourners.length">
            <li v-for="(m, i) in safeMourners" :key="i">
            <b>{{ m.name }}</b>
            <span v-if="m.bankName || m.bankInfo">
                ({{ m.bankName || '은행미기재' }} {{ m.bankInfo || '' }})
            </span>
            <span class="phone"> · {{ formatPhone(m.phoneNumber) }}</span>
            </li>
        </ul>
        <p v-else class="empty">등록된 상주 정보가 없습니다.</p>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import env from '@/env';
import axios from 'axios';

export default {
    props: {
        modalData: Object,
        required: true,
        mournerList:   { type: Array, default: () => [{}] }
    },

    data () {
        return {

        }
    },

    computed: {
        // 빈 항목 정리
        safeMourners() {
            return (this.modalData.mournerList || [])
                .filter(m => (m && (m.name || m.bankName || m.bankInfo || m.phoneNumber)));
        }

    },

    methods: {
        formatPhone(v = '') {
        // 01012345678 → 010-1234-5678 (간단 포맷)
        const s = (v || '').replace(/\D/g, '');
        if (s.length === 11) return `${s.slice(0,3)}-${s.slice(3,7)}-${s.slice(7)}`;
        if (s.length === 10) return `${s.slice(0,3)}-${s.slice(3,6)}-${s.slice(6)}`;
        return v;
        },

        submitPayment() {
        // 결제 로직 연결
        this.$emit('submit', {
            mournerList  : this.safeMourners
        });
        // 필요 시 닫기
        // this.$close();
        }

    },

    mounted() {
        console.log('[Modal] mounted - mournerList:', this.mournerList);
        console.log('[Modal] mounted - modalData:', this.modalData);
        

    }
}

</script>

<style scoped>

.modal ul {
  margin-top: 16px;
  padding: 0;
  list-style: none;
  position: relative;
}
.modal ul::before {
  content: "";
  display: block;
  width: 320px;          /* 구분선 길이 */
  height: 2px;          /* 두께 */
  background: #e5e5e5;  /* 색상 */
  margin: 0 auto 14px;  /* 가운데 정렬 + 아래 여백 */
  border-radius: 2px;
}

/* (선택) 각 항목 사이 얇은 라인 */
.modal ul li {
  padding: 10px 20px;
  border-top: 1px solid #f5f5f5;
  font-size: 1.2rem;
}
.modal ul li:first-child {
  border-top: 0;
}

.modal ul li .phone {
  display: block;       /* 줄바꿈 */
  margin-top: 4px;
  margin-left: 15px;
  line-height: 1.4;
  color: #555;
}

/* (참고) 이름 볼드 최소폭 살짝 */
.modal ul li b {
  font-weight: 600;
  color: #222;
}
</style>